<template>
    <div>
        <!-- <HeaderBacklogComponent 
        ref="headerBacklog"
        :formSeletores="formSeletores"
        :ultimaAtualizacao="listaDeBacklogMacroprocessos.ultima_atualizacao"
        @filterProcessoEmit="filterProcesso"
        @switchMinhaTarefasEmit="switchMinhaTarefas"
        @switchInterrompidasEmit="switchInterrompidas"
        @switchCancelamentoRecadastroEmit="switchCancelamentoRecadastro"
        @abrirFiltroEmit="abrirFiltro"
      /> -->
        <div class="d-flex align-items-center justify-content-between">
          <h3>Painel Circuitos</h3>
          <SGPFormBotaoComponent @click="abrirFiltro">
            <SGPIconComponent icon="mdi-filter" small>
              
            </SGPIconComponent>
            Filtro Avançado</SGPFormBotaoComponent>
        </div>
        <SGPFiltroAvancadoComponent
          filtroCec   
          :abrirFiltroAvancado="abrirFiltroAvancado"
          :formSeletores="formSeletores"
          @sgpFormFilterDadosClick="aplicarFiltro"
          @mudancaStatusEmit="mudancaStatusFiltro"
          @limparDadosEmit="limparDadosFiltro"
        />
      <br>  

    <div class="dashboard-container">
      <SGPGridComponent :columns="8">
        <SGPGridBoxComponent
          v-for="(box, index) in boxes"
          :key="index"
          :title="box.title"
          :value="box.value"
          :color="box.color"
          :text-color="box.textColor"
          :font-size="box.fontSize" 
          :number-size="box.numberSize" 
          :spanColumns="box.spanColumns"
          :spanRows="box.spanRows"
          clickable
          @blur="handleGridBoxClick(box)"
        />
      </SGPGridComponent>
    </div>

    <br />

    <div>
      <SGPRowComponent>
        <SGPColComponent cols="6">
          <div id="chart">
            <!-- <apexchart 
              class="grafico" 
              type="bar" 
              height="460" 
              :options="chartOptions" 
              :key="chartKey" 
              :series="series">
            </apexchart> -->
            <GraficoPainelAlarmeComponent :height="graficoHeight" v-model="graficoClick" :chartOptions="chartOptions" :dados="dadosGrafico" />
          </div>
        </SGPColComponent>
        <SGPColComponent cols="6" ref="tabelasPainelAlarmes">
          <!-- <SGPTabelaComponent
          titulo="Interrupção - Top 10"
          :colunas="colunas"
          :dados="dadosTabela"
          :usuarioPodeExcluir="false"
          :usuarioPodeEditar="false"
          :somenteLeitura="true"
          ></SGPTabelaComponent> -->
          <span class="circuitos-tabela-titulo">PRAZOS A VENCER</span>
          <table :key="tabelaPrazo"  class="table table-painel-alarmes">
            <tr>
              <th></th>
              <th class="text-center">Vencido</th>
              <th class="text-center">5 dias</th>
              <th class="text-center">10 dias</th>
              <th class="text-center">15 dias</th>
              <th class="text-center">20 dias</th>
              <th class="text-center">Sem data</th>
              <th class="text-center"></th>
            </tr>
            <tr >
              <td>
                <strong>Construção</strong>
              </td>
              <td 
                class="text-center cursor-pointer bg-vencido" 
                @click="handleTableClick({name: 'data_previsao_entrega', value: 'VC' }, false, true)"
              >
                {{ tabelaPrazo.prazo_construcao_vencer_eh_vencido }}
              </td>

              <td 
                class="text-center cursor-pointer" 
                @click="handleTableClick({name: 'data_previsao_entrega', value: '5' }, false, true)"
              >
                {{ tabelaPrazo.prazo_construcao_vencer_eh_05 }}
              </td>

              <td 
                class="text-center cursor-pointer" 
                @click="handleTableClick({name: 'data_previsao_entrega', value: '10' }, false, true)"
              >
                {{ tabelaPrazo.prazo_construcao_vencer_eh_10 }}
              </td>

              <td 
                class="text-center cursor-pointer" 
                @click="handleTableClick({name: 'data_previsao_entrega', value: '15' }, false, true)"
              >
                {{ tabelaPrazo.prazo_construcao_vencer_eh_15 }}
              </td>

              <td 
                class="text-center cursor-pointer" 
                @click="handleTableClick({name: 'data_previsao_entrega', value: '20' }, false, true)"
              >
                {{ tabelaPrazo.prazo_construcao_vencer_eh_20 }}
              </td>

              <td 
                class="text-center cursor-pointer bg-grey-light"
                @click="handleTableClick({name: 'data_previsao_entrega', value: 'SD' }, false, true)"
              >
                {{ tabelaPrazo.prazo_construcao_vencer_eh_vazio }}
              </td>

              <td class="text-center">
                <v-btn
                  class=""
                  text
                  icon
                  x-small
                  color="red lighten"
                  @click="abrirModalPorRegional('Construção')"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <td><strong>Ativação</strong></td>
              <td class="text-center cursor-pointer  bg-vencido" @click="handleTableClick({name: 'data_forecast', value: 'VC' })">{{ tabelaPrazo.prazo_ativacao_vencer_eh_vencido }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_forecast', value: '5' })">{{ tabelaPrazo.prazo_ativacao_vencer_eh_05 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_forecast', value: '10' })">{{ tabelaPrazo.prazo_ativacao_vencer_eh_10 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_forecast', value: '15' })">{{ tabelaPrazo.prazo_ativacao_vencer_eh_15 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_forecast', value: '20' })">{{ tabelaPrazo.prazo_ativacao_vencer_eh_20 }}</td>
              <td class="text-center cursor-pointer  bg-grey-light" @click="handleTableClick({name: 'data_forecast', value: 'SD' })">{{ tabelaPrazo.prazo_ativacao_vencer_eh_vazio }}</td>
              <td class="text-center">
                <v-btn
                  class=""
                  text
                  icon
                  x-small
                  color="red lighten"
                  @click="abrirModalPorRegional('Ativação')"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <td><strong>SLA Tecnologia</strong></td>
              <td class="text-center cursor-pointer  bg-vencido" @click="handleTableClick({name: 'sla_tempo_expirar_circuito', value: 'VC' })">{{ tabelaPrazo.prazo_tecnologia_vencer_eh_vencido }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'sla_tempo_expirar_circuito', value: '5' })">{{ tabelaPrazo.prazo_tecnologia_vencer_eh_05 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'sla_tempo_expirar_circuito', value: '10' })">{{ tabelaPrazo.prazo_tecnologia_vencer_eh_10 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'sla_tempo_expirar_circuito', value: '15' })">{{ tabelaPrazo.prazo_tecnologia_vencer_eh_15 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'sla_tempo_expirar_circuito', value: '20' })">{{ tabelaPrazo.prazo_tecnologia_vencer_eh_20 }}</td>
              <td class="text-center cursor-pointer  bg-grey-light" @click="handleTableClick({name: 'sla_tempo_expirar_circuito', value: 'SD' })">{{ tabelaPrazo.prazo_tecnologia_vencer_eh_vazio }}</td>
              <td class="text-center">
                <v-btn
                  class=""
                  text
                  icon
                  x-small
                  color="red lighten"
                  @click="abrirModalPorRegional('SLA Tecnologia')"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
          </table>
          <br>
          <span class="circuitos-tabela-titulo">AGENDAMENTO ATIVAÇÃO</span>
          <table class="table table-painel-alarmes">
            <tr>
              <td rowspan="2"><strong>Agendado</strong></td>
              <th class="text-center">Hoje</th>
              <th class="text-center">dia 1</th>
              <th class="text-center">dia 2</th>
              <th class="text-center">dia 3</th>
              <th class="text-center">dia 4</th>
              <th class="text-center">> 4 dias</th>
              <th></th>
            </tr>
            <tr>
              
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento', value: 'HJ' }, true)">{{ tabelaPrazo.prazo_agendado_eh_hoje }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento', value: '1' }, true)">{{ tabelaPrazo.prazo_agendado_eh_01 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento', value: '2' }, true)">{{ tabelaPrazo.prazo_agendado_eh_02 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento', value: '3' }, true)">{{ tabelaPrazo.prazo_agendado_eh_03 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento', value: '4' }, true)">{{ tabelaPrazo.prazo_agendado_eh_04 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento', value: 'MAIOR_4' }, true)">{{ tabelaPrazo.prazo_agendado_eh_maior_04 }}</td>
              <td class="text-center">
                <v-btn
                  class=""
                  text
                  icon
                  x-small
                  color="red lighten"
                  @click="abrirModalPorRegional('Agendado')"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
            
            <tr>
              <td rowspan="2"><strong>Vencido</strong></td>
              <th class="text-center">dia 1</th>
              <th class="text-center">dia 2</th>
              <th class="text-center">dia 3</th>
              <th class="text-center">dia 4</th>
              <th class="text-center">dia 5</th>
              <th class="text-center">> 5 dias</th>
              <th></th>
            </tr>
            <tr>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento_vencido', value: '1' }, true)">{{ tabelaPrazo.prazo_agendado_vencido_eh_01 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento_vencido', value: '2' }, true)">{{ tabelaPrazo.prazo_agendado_vencido_eh_02 }}</td>
              <td class="text-center cursor-pointer" @click="handleTableClick({name: 'data_agendamento_vencido', value: '3' }, true)">{{ tabelaPrazo.prazo_agendado_vencido_eh_03 }}</td>
              <td class="text-center cursor-pointer bg-vencido" @click="handleTableClick({name: 'data_agendamento_vencido', v, truealue: '4' }, true)">{{ tabelaPrazo.prazo_agendado_vencido_eh_04 }}</td>
              <td class="text-center cursor-pointer bg-vencido" @click="handleTableClick({name: 'data_agendamento_vencido', value: '5' }, true)">{{ tabelaPrazo.prazo_agendado_vencido_eh_05 }}</td>
              <td class="text-center cursor-pointer bg-vencido" @click="handleTableClick({name: 'data_agendamento_vencido', value: 'MAIOR_5' }, true)">{{ tabelaPrazo.prazo_agendado_vencido_eh_maior_05 }}</td>
              <td class="text-center">
                <v-btn
                  class=""
                  text
                  icon
                  x-small
                  color="red lighten"
                  @click="abrirModalPorRegional('Vencido')"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
          </table>
        </SGPColComponent>
      </SGPRowComponent>
      <div class="box-container">
          <div v-for="macroprocesso in macroprocessos" :key="macroprocesso.id" class="box">
              {{ macroprocesso.nome }} <!-- Adjust based on your data structure -->
          </div>
      </div>
    </div>

    <div>
      <SGPRowComponent>
          <!-- <SGPTabelaComponent
              :colunas="colunasAlarmes"
              :dados="dadosAlarmes"              
          ></SGPTabelaComponent>
          <SGPTabelaComponent
              :colunas="colunasPrazo"
              :dados="dadosPrazo"              
          ></SGPTabelaComponent>
          <SGPTabelaComponent
              :colunas="colunasAgendado"
              :dados="dadosAgendado"              
          ></SGPTabelaComponent>
          <SGPTabelaComponent
              :colunas="colunasVencido"
              :dados="dadosVencido"
              :esconderHeader="True"              
          ></SGPTabelaComponent>     
          <TabelaPrazosComponent></TabelaPrazosComponent> -->
      </SGPRowComponent>  
    </div>

    <ModalDetalheTarefasComponent 
        v-if="abrirModalAnalitico"
        :filtrosTarefas="filtroPayload"
        @sgpModalFechar="fecharModal"
     />
    <SGPLoadingComponent v-if="loadingBacklog" />

    <ModalTabelaPorRegionalComponent
      v-if="abrirModalTabelaPorRegional"
      :titulo="tituloModalPorRegional"
      :dados="listaTarefasBacklogBoxPainelAlarmes"
      :linha="linhaSelecionada"
      @sgpModalFechar="abrirModalTabelaPorRegional = false"
    />

  </div>
  
</template>
  
<script>
import { mapActions, mapGetters } from 'vuex'
import {  getRegionaisDoUsuario } from '@/common/helpers/FiltroAvancado.js'
import ModalDetalheTarefasComponent from '../components/ModalDetalheTarefasComponent.vue'
import ModalTabelaPorRegionalComponent from '../components/ModalTabelaPorRegionalComponent.vue'
import GraficoPainelAlarmeComponent from '../components/GraficoPainelAlarmeComponent.vue'
import { dadosBoxesPainelAlarmes } from '../mock/BoxesPainelAlarmes.js'


  export default {
    name: "PainelAlarmes",
    components: {
      ModalDetalheTarefasComponent,
      GraficoPainelAlarmeComponent,
      ModalTabelaPorRegionalComponent
    },
    data() {
      return {
        graficoHeight: '400',
        abrirModalAnalitico: false,
        formSeletores: {
          user_tratamento_id: '',
          interrupcoes: '',
          cancelamento_recadastro: false,
          cod_cir: '',
          projeto_migracao: '',
          disponibilizados: '',
        },
        graficoClick: {},
        abrirModalTabelaPorRegional: false,
        tituloModalPorRegional: '',
        linhaSelecionada: '',
        abrirFiltroAvancado: false,
        filtroPayload: {},
        dados: '',
        chartKey: 0,
        
        chartOptions: {
          chart: {
            height: 350,
            type: 'bar',
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: 'rounded',
              dataLabels: {
                position: 'outside', // Position the data labels on top of the bars
              },
            },
          },
          dataLabels: {
            enabled: true,
            position: 'top', // Position the data labels
            style: {
              fontSize: '18px',
              fontWeight: 'light',
              colors: ['#000'], // Change label color to black
            },
          },
          stroke: {
            colors: ['#DA291C', '#FC867F', '#525252'],
          },
          xaxis: {
            categories: [
              '1. Definir Solução', 
              '2. Construir Acesso', 
              '3. Aprovisionar Serviço', 
              '4. Preparar Ativação', 
              '5. Ativar Serviço'
            ],
          },
          title: {
            text: 'Registros por macro processo',
            align: 'center',
          },
          yaxis: {
            title: {
              text: 'Número de Registros',
            },
          },
          colors: ['#DA291C', '#FC867F', '#FB9C2D', '#005C66', '#00818F'],
          tooltip: {
            shared: true,
            intersect: false,
          },
        },
  
      };
    },
  async mounted () {
      // await this.setParametrosFiltroPayload();
  
      this.filtrarBacklogMacroprocessos(this.filtroPayload);
      this.listarDadosPainelAlarmes(this.filtroPayload)

      let tabelasHeight = this.$refs.tabelasPainelAlarmes.$el.clientHeight;
      const compensacaoTamanhoTela =  this.$vuetify.breakpoint.width > 1420 ? 0 : 80
      this.graficoHeight = tabelasHeight + compensacaoTamanhoTela      
  },

   computed:{
      ...mapGetters('backlog', [
        'listaDeBacklogMacroprocessos',
        'listaTarefasBacklogBoxPainelAlarmes',
        'loadingBacklog'
      ]),

    tabelaPrazo () {

      let prazos =  {
        prazo_ativacao_vencer_eh_05: 0,
        prazo_ativacao_vencer_eh_10: 0,
        prazo_ativacao_vencer_eh_15: 0,
        prazo_ativacao_vencer_eh_20: 0,
        prazo_ativacao_vencer_eh_vazio: 0,
        prazo_ativacao_vencer_eh_vencido: 0,

        prazo_construcao_vencer_eh_05: 0,
        prazo_construcao_vencer_eh_10: 0,
        prazo_construcao_vencer_eh_15: 0,
        prazo_construcao_vencer_eh_20: 0,
        prazo_construcao_vencer_eh_vazio: 0,
        prazo_construcao_vencer_eh_vencido: 0,

        prazo_tecnologia_vencer_eh_05: 0,
        prazo_tecnologia_vencer_eh_10: 0,
        prazo_tecnologia_vencer_eh_15: 0,
        prazo_tecnologia_vencer_eh_20: 0,
        prazo_tecnologia_vencer_eh_vazio: 0,
        prazo_tecnologia_vencer_eh_vencido: 0,

        prazo_agendado_eh_hoje: 0,
        prazo_agendado_eh_01: 0,
        prazo_agendado_eh_02: 0,
        prazo_agendado_eh_03: 0,
        prazo_agendado_eh_04: 0,
        prazo_agendado_eh_maior_04: 0,

        prazo_agendado_vencido_eh_01: 0,
        prazo_agendado_vencido_eh_02: 0,
        prazo_agendado_vencido_eh_03: 0,
        prazo_agendado_vencido_eh_04: 0,
        prazo_agendado_vencido_eh_05: 0,
        prazo_agendado_vencido_eh_maior_05: 0,
      }

      if (this.listaTarefasBacklogBoxPainelAlarmes) {
        const tabelaPrazos = this.listaTarefasBacklogBoxPainelAlarmes       
        prazos.prazo_ativacao_vencer_eh_05 = tabelaPrazos.prazo_ativacao_vencer_eh_05
        prazos.prazo_ativacao_vencer_eh_10 = tabelaPrazos.prazo_ativacao_vencer_eh_10
        prazos.prazo_ativacao_vencer_eh_15 = tabelaPrazos.prazo_ativacao_vencer_eh_15
        prazos.prazo_ativacao_vencer_eh_20 = tabelaPrazos.prazo_ativacao_vencer_eh_20
        prazos.prazo_ativacao_vencer_eh_vazio = tabelaPrazos.prazo_ativacao_vencer_eh_vazio
        prazos.prazo_ativacao_vencer_eh_vencido = tabelaPrazos.prazo_ativacao_vencer_eh_vencido
        prazos.prazo_construcao_vencer_eh_05 = tabelaPrazos.prazo_construcao_vencer_eh_05
        prazos.prazo_construcao_vencer_eh_10 = tabelaPrazos.prazo_construcao_vencer_eh_10
        prazos.prazo_construcao_vencer_eh_15 = tabelaPrazos.prazo_construcao_vencer_eh_15
        prazos.prazo_construcao_vencer_eh_20 = tabelaPrazos.prazo_construcao_vencer_eh_20
        prazos.prazo_construcao_vencer_eh_vazio = tabelaPrazos.prazo_construcao_vencer_eh_vazio
        prazos.prazo_construcao_vencer_eh_vencido = tabelaPrazos.prazo_construcao_vencer_eh_vencido
        prazos.prazo_tecnologia_vencer_eh_05 = tabelaPrazos.prazo_tecnologia_vencer_eh_05
        prazos.prazo_tecnologia_vencer_eh_10 = tabelaPrazos.prazo_tecnologia_vencer_eh_10
        prazos.prazo_tecnologia_vencer_eh_15 = tabelaPrazos.prazo_tecnologia_vencer_eh_15
        prazos.prazo_tecnologia_vencer_eh_20 = tabelaPrazos.prazo_tecnologia_vencer_eh_20
        prazos.prazo_tecnologia_vencer_eh_vazio = tabelaPrazos.prazo_tecnologia_vencer_eh_vazio
        prazos.prazo_tecnologia_vencer_eh_vencido = tabelaPrazos.prazo_tecnologia_vencer_eh_vencido
        prazos.prazo_agendado_eh_hoje = tabelaPrazos.prazo_agendado_eh_hoje
        prazos.prazo_agendado_eh_01 = tabelaPrazos.prazo_agendado_eh_01
        prazos.prazo_agendado_eh_02 = tabelaPrazos.prazo_agendado_eh_02
        prazos.prazo_agendado_eh_03 = tabelaPrazos.prazo_agendado_eh_03
        prazos.prazo_agendado_eh_04 = tabelaPrazos.prazo_agendado_eh_04
        prazos.prazo_agendado_eh_maior_04 = tabelaPrazos.prazo_agendado_eh_maior_04
        prazos.prazo_agendado_vencido_eh_01 = tabelaPrazos.prazo_agendado_vencido_eh_01
        prazos.prazo_agendado_vencido_eh_02 = tabelaPrazos.prazo_agendado_vencido_eh_02
        prazos.prazo_agendado_vencido_eh_03 = tabelaPrazos.prazo_agendado_vencido_eh_03
        prazos.prazo_agendado_vencido_eh_04 = tabelaPrazos.prazo_agendado_vencido_eh_04
        prazos.prazo_agendado_vencido_eh_05 = tabelaPrazos.prazo_agendado_vencido_eh_05
        prazos.prazo_agendado_vencido_eh_maior_05 = tabelaPrazos.prazo_agendado_vencido_eh_maior_05
      }

      return prazos
    },

      boxes () {
        if (this.listaTarefasBacklogBoxPainelAlarmes) {
          const painelAlarmes = this.listaTarefasBacklogBoxPainelAlarmes

          return dadosBoxesPainelAlarmes(painelAlarmes)
        }

        return []
      },

      macroprocessosGrafico () {
        if (this.listaTarefasBacklogBoxPainelAlarmes) {
          return this.listaTarefasBacklogBoxPainelAlarmes.graficos
        }

        return []
      },

      dadosGrafico () {
        let dados = [{
          name: 'Tarefas',
          data: [],
        }]

        if (this.listaTarefasBacklogBoxPainelAlarmes) {
          dados[0].data = this.listaTarefasBacklogBoxPainelAlarmes.graficos.map(graph =>{
            return graph.qtd_tarefa
          })
        }

        return dados
      },
      colunasVencido () {
        return [
        {
          key: 'fase',
          label: '',
          sortable: false
        },
        {
          key: 'diaum',
          label: '1 dia',
          sortable: false
        },
        {
          key: 'diadois',
          label: '2 dias',
          sortable: false
        },
        {
          key: 'diatres',
          label: '3 dias',
          sortable: false
        },
        {
          key: 'diaquatro',
          label: '4 dias',
          sortable: false
        },
        {
          key: 'diacinco',
          label: '5 dias',
          sortable: false
        },
        {
          key: 'maiorquatro',
          label: '> 5 dias',
          sortable: false
        },
      ]
      },
      colunasAgendado () {
        return [
        {
          key: 'fase',
          label: '',
          sortable: false
        },
        {
          key: 'hoje',
          label: 'Hoje',
          sortable: false
        },
        {
          key: 'diaum',
          label: 'dia 1',
          sortable: false
        },
        {
          key: 'diadois',
          label: 'dia 2',
          sortable: false
        },
        {
          key: 'diatres',
          label: 'dia 3',
          sortable: false
        },
        {
          key: 'diaquatro',
          label: 'dia 4',
          sortable: false
        },
        {
          key: 'maiorquatro',
          label: '> 4 dias',
          sortable: false
        },
      ]
      },
      colunasPrazo () {
      return [
        {
          key: 'fase',
          label: '',
          sortable: false
        },
        {
          key: 'cincodias',
          label: '5 dias',
          sortable: false
        }, 
        {
          key: 'dezdias',
          label: '10 dias',
          sortable: false
        },
        {
          key: "quinzedias",
          label: "15 dias",
          sortable: false,
        },
        {
          key: 'vintedias',
          label: '20 dias',
          sortable: false
        },
        {
          key: "semdata",
          label: "Sem data",
          sortable: false,
        },
      ]
    },
      colunasAlarmes () {
      return [
        {
          key: 'classificacao',
          label: 'Classificacao e Prazo',
          sortable: false
        }, 
        {
          key: 'zerodia',
          label: '0 dia',
          sortable: false
        },
        {
          key: 'umdia',
          label: '1 dia',
          sortable: false
        },
        {
          key: "doisdias",
          label: "2 dias",
          sortable: false,
        },
        {
          key: "tresdias",
          label: "3 dias",
          sortable: false,
        },
      ]
    },  
      colunas () { 
        return [ 
          {
            key: 'quantidade',
            label: 'Quantidade',
            sortable: false
          },
          {
            key: 'tarefa',
            label: 'Tarefa',
            sortable: false
          }
        ]
      },
    },
    
    methods: {
      ...mapActions('backlog',[
        'filtrarBacklogMacroprocessos',
        'filtrarBacklogTarefasMacroprocessos',
        'filtrarBacklogTarefasInterrupcoes',
        'listarDadosPainelAlarmes'
      ]),
      abrirFiltro () {
        this.abrirFiltroAvancado = true;
      },
      setParametrosFiltroPayload (){
        if(localStorage.filtroAvancado) {
          this.filtroPayload = JSON.parse(localStorage.filtroAvancado)
        }else {
          this.filtroPayload = {
            ...this.formSeletores,
            ...{
              ctrl_regional_id: getRegionaisDoUsuario(),
            }
          }
        } 
      },
      macroprocessosFiltrado (val) {
        return this.listaDeBacklogMacroprocessos.detalhado.filter(macro => { return macro.ctrl_macro_processo_id == val })      
      },
      
      
      getParamFiltro () {
        if(localStorage.filtroAvancado) {    
            this.filtroPayload = JSON.parse(localStorage.filtroAvancado)
            this.filtroPayload.user_tratamento_id = this.formSeletores.user_tratamento_id  
            this.filtroPayload.cancelamento_recadastro = this.formSeletores.cancelamento_recadastro
          } else {
            const payload = {          
            ...this.formSeletores,        
            ...this.filtroPayload,
            }           
            this.filtroPayload = payload          
          }
      },
      limparDadosFiltro (){
        this.formSeletores.cod_cir = ''
        this.formSeletores.user_tratamento_id = false
        this.formSeletores.interrupcoes = false
        this.formSeletores.cancelamento_recadastro = false
        this.formSeletores.projeto_migracao = ''
        this.formSeletores.disponibilizados = ''
        this.getParamFiltro()
      },
      mudancaStatusFiltro (val) {
        this.abrirFiltroAvancado = val;
      },

      async handleGridBoxClick (val) {
        const payload = {
          ...this.filtroPayload,          
          item: { [val.name]: 1, emCancelamento: 0 }
        }

        /// os filtros instalavel são baseados somente em tarefas interrompidas
        if (['instalavel', 'naoInstalavel'].includes(val.name)) {
          payload.item.interrompida = 1
        }

        if (val.payload) {
          const dadosPaylodBox = val.payload.reduce(
            (obj, item) => ({...obj, [item.name]: item.value,  emCancelamento: 0}) ,{}
          )
          payload.item = dadosPaylodBox
        }

        this.filtroPayload = payload
        this.abrirModalAnalitico = true
      },

      async handleTableClick (val, agendamento = false, construcao = false) {
        let macroProcesso = {}

        if (agendamento) {
          macroProcesso = {
            "ctrlMacroProcessoId": 25
          }
        }

        if (construcao) {
          macroProcesso = {
            "ctrlMacroProcessoId": [4, 15]
          }
        }
        
        const payload = {
          ...this.filtroPayload,
          emCancelamento: 0,
          item: {
            [val.name]: val.value,
            ...macroProcesso,
            emCancelamento: 0
          }
        }
        
        this.filtroPayload = payload
        this.abrirModalAnalitico = true
      },
  
      async aplicarFiltro (dados) {
        this.getParamFiltro();
  
        let filtroLateralPayload = {
          ...dados,
          ...this.formSeletores,
          ...{ 'ctrl_processo_id' : this.filtroPayload.ctrl_processo_id ? this.filtroPayload.ctrl_processo_id : '' },
        } 
  
        this.filtroPayload = filtroLateralPayload 
  
        await this.listarDadosPainelAlarmes(this.filtroPayload )
  
        this.abrirFiltroAvancado = true
      },

      fecharModal() {
        this.abrirModalAnalitico = false;
      },

      abrirModalPorRegional(titulo) {
        this.tituloModalPorRegional = titulo
        this.linhaSelecionada = this.$slugfy(titulo);
        this.abrirModalTabelaPorRegional = true
      },
    },

    watch: {
      async graficoClick (val) {
        if (val) {
          const macroprocesso = this.macroprocessosGrafico[val.dataPointIndex]

          const payload = {
            ...this.filtroPayload,
            item: {
              ctrlMacroProcessoId: macroprocesso.ctrl_macro_processo_id,
              emCancelamento: 0
            }
          }
          this.filtroPayload = payload
          this.abrirModalAnalitico = true
        }
      }
    }
    
  };
  </script>
  
  <style lang="scss" scoped>

  .bg-grey-light {
    background-color: #ddd;
  }
 
  .grid-container {
    display: grid;
    grid-template-columns: repeat(8, 1fr); /* 8 equal columns */    
    gap: 15px !important; /* Space between boxes */
  }
  .invisible-box {
    background-color: transparent; /* Makes the box invisible */
    border: 1px solid transparent; /* Optional: keep space for the border */
    height: 100px; /* Set the height */
    width: 100%; /* Set the width (or specific span in a grid) */
  }
  
  .box-maior {
    display: flex; /* Keep Flexbox for internal content alignment */
    flex-direction: column; /* Stack content vertically */
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    background-color: rgb(252, 254, 254); /* For visibility */
    text-align: center;
    border: 1px solid #ccc;
    height: 130%;
    padding: 20px;
  
  }
    
  .box {
    display: flex; /* Use Flexbox */
    flex-direction: column;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    background-color: rgb(252, 254, 254); /* Just for visibility */
    padding: 20px;
    text-align: center;
    border: 1px solid #ccc;
    text-align: center;
  }
  
  .grafico {
    position: relative;
    z-index: 5;
  }
  
  .valor-highlight {
    color: gray; /* Change this to your desired color */
    font-weight: bold; /* Optional styling */
  }
  
  .circuitos-texto {
    color: #51555D;
    text-align: center;
    font-size: 36px; 
  }
  
  .circuitos-valor {
    color: #51555D;
    font-weight: bold; 
    font-size: 48px; 
  }
  
  
  .circuitos-valor-andamento {
    color: #A61D19;
    font-weight: bold; 
    font-size: 48px; 
  }
  
  .circuitos-valor-alerta {
    color: #FFBC4A;
    font-weight: bold; 
    font-size: 48px; 
  }
  
  .circuitos-valor-andamento-azul {
    color: #08abb4;
    font-weight: bold; 
    font-size: 64px; 
  }

  .circuitos-tabela-titulo {
  display: block; /* Ensures the span behaves like a block element */
  width: 100%; /* Makes the span take full width of the parent */
  background-color:  #df323b; /* Background color */
  color: white; /* Text color */
  padding: 8px; /* Padding for spacing */
  font-weight: bold; /* Makes the text bold */
  text-align: center; /* Center the text */
  font-size: 18px;
  }

  .table-painel-alarmes {
    tr {
      td, th {
        border: solid 1px #bdbdbd !important;
        padding: 4px 8px;
      }

      th {
        color: #df323b;
      }
    }
  }
  </style>
  